import { render } from "./updatecomp.vue?vue&type=template&id=3023022a&scoped=true"
import script from "./updatecomp.vue?vue&type=script&lang=js"
export * from "./updatecomp.vue?vue&type=script&lang=js"

import "./updatecomp.vue?vue&type=style&index=0&id=3023022a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3023022a"]])

export default __exports__